import styled from 'styled-components'

import ActionButton from '../ActionButton'
import { mq, sizes } from '../../theme'
import Icon from '../Icon'

export const HeaderSearch = styled.section`
  background: ${({ theme }) => theme.colors.pureWhite};
  display: flex;
  align-items: center;
`

export const HeaderSearchContent = styled.div`
  width: 100%;
`

export const Form = styled.form`
  background: ${({ theme }) => theme.colors.pureWhite};
  display: flex;
  flex-direction: column;
  @media ${mq(sizes.desktop)} {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr min-content;
    column-gap: 1rem;
    padding: 0 2rem;
    min-height: 4rem;
    border-radius: 2.5rem;
  }
`
export const InputWrapper = styled.div`
  position: relative;
`

export const Svg = styled(Icon)`
  width: 2.2rem;
  height: 2.2rem;
  display: block;
  position: absolute;
  inset: 50% auto auto 1.4rem;
  transform: translateY(-50%);
`

export const Input = styled.input`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16};
  color: ${({ theme }) => theme.colors.pureBlack};
  background: ${({ theme }) => theme.colors.pureWhite};
  border: none;
  appearance: none;
  width: 100%;
  min-height: 4rem;
  border: 1px solid ${({ theme }) => theme.colors.greyCE};
  box-shadow: inset 0.3rem 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.07);
  border-radius: 3.5rem;
  padding-left: 4.5rem;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    ${({ theme }) => theme.textStyles.text_16}
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey82};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    ${({ theme }) => theme.textStyles.text_16}
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey82};
  }
`

export const Button = styled(ActionButton)`
  margin: 1.3rem 0 0;
  @media ${mq(sizes.desktop)} {
    margin: 0;
  }
`
